import * as styles from './checkbox.module.scss';

export enum CheckboxSize {
    Medium = 'medium',
    Large = 'large'
}

export const CheckboxColorsForRevelantSection = [styles.blue, styles.red, styles.teal];

interface Props {
    color: string;
    size: CheckboxSize;
    text: string;
}

export const Checkbox = ({ color, size, text }: Props) => (
    <div className={`${styles.checkbox} ${styles[size]}`}>
        <svg xmlns="http://www.w3.org/2000/svg" width="40" height="41" viewBox="0 0 40 41" fill="none">
            <mask id="mask0_89_38987" maskUnits="userSpaceOnUse" x="1" y="1" width="38" height="38">
                <path
                    d="M19.9999 36.7791C22.189 36.782 24.3571 36.3522 26.3796 35.5144C28.4021 34.6766 30.239 33.4475 31.7849 31.8975C33.3349 30.3516 34.5641 28.5146 35.4019 26.4922C36.2396 24.4697 36.6694 22.3016 36.6666 20.1125C36.6694 17.9234 36.2396 15.7553 35.4018 13.7328C34.564 11.7104 33.3349 9.8734 31.7849 8.32748C30.239 6.7775 28.4021 5.54831 26.3796 4.71055C24.3571 3.87279 22.189 3.44298 19.9999 3.44581C17.8108 3.44302 15.6428 3.87286 13.6203 4.71062C11.5978 5.54837 9.76085 6.77754 8.21493 8.32748C6.66499 9.8734 5.43583 11.7104 4.59807 13.7328C3.76031 15.7553 3.33048 17.9234 3.33327 20.1125C3.33043 22.3016 3.76024 24.4697 4.598 26.4922C5.43576 28.5146 6.66496 30.3516 8.21493 31.8975C9.76085 33.4474 11.5978 34.6766 13.6203 35.5143C15.6428 36.3521 17.8108 36.7819 19.9999 36.7791Z"
                    fill="white"
                    stroke="white"
                    strokeWidth="3.33333"
                    strokeLinejoin="round"
                />
                <path
                    d="M13.3333 20.1118L18.3333 25.1118L28.3333 15.1118"
                    stroke="black"
                    strokeWidth="3.33333"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </mask>
            <g mask="url(#mask0_89_38987)">
                <path d="M0 0.111816H40V40.1118H0V0.111816Z" fill={color} />
            </g>
        </svg>
        {size === CheckboxSize.Medium ? <h4>{text}</h4> : <h5>{text}</h5>}
    </div>
);
